import(/* webpackMode: "eager" */ "/home/turath2/turath-websites/turath-website-learn/en-dev/app/(website)/(main)/error.tsx");
